import { render, staticRenderFns } from "./HighPostPicker.vue?vue&type=template&id=bc356f36&scoped=true"
import script from "./HighPostPicker.vue?vue&type=script&lang=js"
export * from "./HighPostPicker.vue?vue&type=script&lang=js"
import style0 from "./HighPostPicker.vue?vue&type=style&index=0&id=bc356f36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc356f36",
  null
  
)

export default component.exports